import untitled_full from './assets/portfolio/untitled500x763.jpg'
import untitled from './assets/mobile/untitledthumb.jpg'
import portals_full from './assets/portfolio/portals500x642.png'
import portals from './assets/mobile/portalsthumb.png'
import lion_full from './assets/portfolio/lion500x555.png'
import lion from './assets/mobile/lionthumb.png'
import thedepths_full from './assets/portfolio/thedepthsink800x586.jpg'
import thedepths from './assets/mobile/thedepthsinkthumb.jpg'
import hh_full from './assets/portfolio/hh500x696.png'
import hh from './assets/mobile/hhthumb.png'
import oil_full from './assets/portfolio/oil500x667.jpg'
import oil from './assets/mobile/oilthumb.jpg'
import mask_full from './assets/portfolio/Mask567x567.jpg'
import mask from './assets/mobile/maskthumb.jpg'
import gardenofeden_full from './assets/portfolio/gardenofeden1440x1176.jpg'
import gardenofeden from './assets/mobile/gardenofedenthumb.jpg'
import train_full from './assets/portfolio/train600x807.jpg'
import train from './assets/mobile/trainthumb.png'
import mswhite_full from './assets/portfolio/mswhite.png'
import mswhite from './assets/mobile/mswhitethumb.png'
import awakening_full from './assets/portfolio/awakening-737x1024.png'
import awakening from './assets/mobile/awakeningthumb.png'
import vanity_full from './assets/portfolio/vanity700x459.jpg'
import vanity from './assets/mobile/vanitythumb.png'
import thrivedemon_full from './assets/portfolio/thrivewings.jpg'
import thrivedemon from './assets/mobile/thrivedemonthumb.png'
import thrivewings_full from './assets/portfolio/thrive.jpg'
import thrivewings from './assets/mobile/thrivewingsthumb.png'
import nightmare_full from './assets/portfolio/nightmare.jpg'
import nightmare from './assets/mobile/nightmarethumb.png'

export const imageSrc = {
    untitled_full: untitled_full, untitled,
    portals_full, portals,
    lion_full, lion,
    thedepths_full, thedepths,
    hh_full, hh,
    oil_full, oil,
    mask_full, mask,
    gardenofeden_full, gardenofeden,
    train_full, train,
    mswhite_full, mswhite,
    awakening_full, awakening,
    vanity_full, vanity,
    thrivedemon_full, thrivedemon,
    thrivewings_full, thrivewings,
    nightmare_full, nightmare
}

export default imageSrc